import { ReactElement } from 'react';
import { BaseIcon, BaseIconProps } from '../BaseIcon';

export enum AIStarIconColorVariant {
  CURRENT_COLOR = 'currentColor',
  BRAND_AI = '#FF8B19',
}

type AIStarIconProps = {
  colorVariant?: AIStarIconColorVariant;
} & Omit<BaseIconProps, 'children'>;

export const AIStarIcon = ({
  colorVariant = AIStarIconColorVariant.CURRENT_COLOR,
  ...props
}: AIStarIconProps): ReactElement => (
  <BaseIcon width="18" height="18" viewBox="0 0 18 18" {...props}>
    <path
      fill={colorVariant}
      d="M9 0a1 1 0 0 1 .95.684L11.79 6.21l5.525 1.842a1 1 0 0 1 0 1.896l-5.525 1.841-1.842 5.527a1 1 0 0 1-1.897 0L6.209 11.79.684 9.948a1 1 0 0 1 0-1.896l5.525-1.843L8.052.684l.061-.147A1 1 0 0 1 9 0M7.95 7.316a1 1 0 0 1-.634.632L4.161 9l3.155 1.052.109.043a1 1 0 0 1 .524.589L9 13.837l1.052-3.153.043-.109a1 1 0 0 1 .589-.523L13.839 9l-3.155-1.052a1 1 0 0 1-.632-.632L9 4.162z"
    ></path>
  </BaseIcon>
);

AIStarIcon.displayName = 'AIStarIcon';
